import useApiClient from '../../Base/Hooks/useApiClient';
import apiClient from '../../../Services/ApiClient';

export default function useKDARConnection() {
	const { displayError } = useApiClient();
	const loadDataFromNIS = async (birthNumber: string) => {
		try {
			const response = await apiClient.get(
				`/kdar/kdar-nis/${birthNumber.replace('/', '')}`,
			);
			if (response.status === 200) {
				const data = response.data;
				const address = data?.patientAddress;
				const patientContact = data?.patientContact;
				return {
					insuranceNumber: data?.birthNumber,
					firstName: data?.firstName ?? undefined,
					lastName: data?.lastName ?? undefined,
					address: address
						? {
								street: address?.street,
								city: address?.city,
								postCode: address?.postCode,
								descriptiveNumber: address?.houseNumber,
						  }
						: undefined,
					healthInsuranceCompany: data?.insurance
						? {
								value: data?.insurance?.id,
								label: `${data?.insurance?.value} - ${data?.insurance?.value2}`,
						  }
						: undefined,
					legalRepresentative: patientContact
						? {
								phoneNumber: patientContact?.phone
									? '+420' + patientContact?.phone
									: undefined,
								email: patientContact?.email ?? undefined,
						  }
						: undefined,
					note: data?.note ?? undefined,
				};
			}
		} catch (e) {
			displayError(e);
		}
	};

	return { loadDataFromNIS };
}
